






























































































































































































































































import { CustomDetailItemInfo } from '@/store/custom/statistic/types';
import { dateFilter } from '@/utils/date-util';
import { notifyError, notifySuccess } from '@/utils/notify-helper';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { colorClassByStatus } from '@/utils/page-utils';
import axios, { AxiosResponse } from 'axios';
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";

@Component({ filters: {dateFilter}, methods: {colorClassByStatus} })
export default class CustomDetailInfo extends Vue {
  @Action('getCustomStatisticDetailInfo') actionGetItem: any;
  @Action('resendCustomMessage') actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  private messageInfo: CustomDetailItemInfo = new CustomDetailItemInfo();
  private transport = MsgTransports.CUSTOM;
  private logObject: ActionLog = {};

  async created(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      const response: AxiosResponse<CustomDetailItemInfo> = await this.actionGetItem(this.$route.params.id);
      await this.actionLog(this.logObject);
      this.messageInfo = response.data;
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  back(): void {
    this.$router.push('/custom/detail/');
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      await this.actionResendMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
      notifySuccess(this.$t('dialog.resend').toString());
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  get isShowFinanceInfo(): boolean {
    return localStorage.getItem('show-finance-info') === 'true';
  }

  private goToTheLink(link: string): void {
    window.location.href = link;
  }
}
